import { render, staticRenderFns } from "./AdditionalFeePayee.vue?vue&type=template&id=48518928&"
import script from "./AdditionalFeePayee.vue?vue&type=script&lang=js&"
export * from "./AdditionalFeePayee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48518928')) {
      api.createRecord('48518928', component.options)
    } else {
      api.reload('48518928', component.options)
    }
    module.hot.accept("./AdditionalFeePayee.vue?vue&type=template&id=48518928&", function () {
      api.rerender('48518928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/AdditionalFeePayee.vue"
export default component.exports